import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from "@/views/layout.vue"

// const layout = () => import('@/views/layout.vue');
Vue.use(VueRouter)
//push 
const VueRouterPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

const routes = [
	{
		path: '/404',
		component: () => import('@/views/errorPage/404'),
		hidden: true
	},
	{
		path: '/',
		component: layout,
		children: [
			{
				path: '/',
				name: "首页",
				component: () => import('@/views/home/index.vue')
			},
			{
				path: '/address/:id',
				name: "详情",
				component: () => import('@/views/home/details.vue')
			},
			{
				path: '/blocks',
				name: "区块列表",
				component: () => import('@/views/block/index.vue')
			},
			{
				path: '/block/:id',
				name: "区块详情",
				component: () => import('@/views/block/blockDetails.vue')
			},
			{
				path: '/txs',
				name: "交易列表",
				component: () => import('@/views/trade/index.vue')
			},
			{
				path: '/tx/:id',
				name: "交易详情",
				component: () => import('@/views/trade/tradeDetails.vue')
			},
			{
				path: '/contract/:id',
				name: "合约",
				component: () => import('@/views/contract/index.vue')
			},
			{
				path: '/token/:id',
				name: "代币",
				component: () => import('@/views/token/index.vue')
			},
			{
				path: '/mobileTx/:id',
				name: "交易详情",
				component: () => import('@/views/trade/mobileDetails.vue')
			},
			
		]
	}
]

const router = new VueRouter({
	mode: 'history',
	routes
})

export default router